import { render, staticRenderFns } from "./ShiftAtomForm.vue?vue&type=template&id=5c015b1c&"
import script from "./ShiftAtomForm.vue?vue&type=script&lang=ts&"
export * from "./ShiftAtomForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports